<template>
<div id="course_last" :class="{finished}">

	<template v-if="finished">
		<div class="finished">
			<sticker src="success.png" :width="128"/>
		</div>
	</template>

	<div class="caption">
		<span v-if="finished">{{$t('snippity.course.coursesuccess')}}</span> <span>{{course.name}}</span>
	</div>

	<div class="cover">
		<bgimage :src="course.cover"/>
	</div>

	<div class="buttonWrapper">
		<button class="button" @click="click">{{$t('snippity.course.gotoback')}}</button>
	</div>

	<div class="logowrapper">
        <logotype />
    </div>

</div>
</template>

<style scoped lang="sass">

#course_last
	display: flex
	flex-flow: column
	justify-content: center
	align-items: center

	.buttonWrapper
		margin-top: 2 * $r

	.cover
		margin-top: 2 * $r
		.bgimage
			border-radius: 90px
			width: 180px
			height: 180px
			+transition(0.3s)

	&.finished
		.cover
		
			.bgimage
				border-radius: 90px
				width: 80px
				height: 80px

	.caption
		margin-top: 2 * $r
		text-align: center
		padding : 0 2 * $r
		max-width: 300px
		color : srgb(--neutral-grad-4)

		span
			font-size: 1.5em
			font-weight: 700

	.logowrapper
		margin-top: 2 * $r

</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'course_last',
	props: {
		course : Object
	},
	computed: mapState({
		auth: state => state.auth,
		userinfo: state => state.userinfo,
		progress : function(state){

            if(!this.course) return new this.core.api.kt.LessonProgress()

            return state._progress[this.course.uid] || (new this.core.api.kt.LessonProgress())
        },

		finished : function(){
			if(this.course){
				return this.progress.finished(this.course)
			}
		}
	}),

	methods: {
		click : function(){
			this.$emit('cevent', {
				name : "toback"
			})
		}
	},
}
</script>
